(() => {
  const SECTION = '.section-template--26526685561174__feature_cards_wWdnk3-padding';
  const ITEMS   = `${SECTION} .icon-column-section__list > li .card-box__content`;

  function equalize() {
    const contents = document.querySelectorAll(ITEMS);
    if (!contents.length) return;

    // reset heights
    contents.forEach(c => c.style.minHeight = '');

    // trova altezza massima
    let maxH = 0;
    contents.forEach(c => { maxH = Math.max(maxH, c.offsetHeight); });

    // applica a tutte
    contents.forEach(c => c.style.minHeight = maxH + 'px');
  }

  // run on load + resize
  window.addEventListener('load', equalize);
  window.addEventListener('resize', equalize);

  // ricalcola quando immagini/video dentro la sezione sono caricati
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector(SECTION);
    if (section) {
      section.querySelectorAll('img, video').forEach(el => {
        el.addEventListener('load', equalize);
        el.addEventListener('loadeddata', equalize);
      });
    }
  });
})();